// extracted by mini-css-extract-plugin
export default {"card_title":"Header_card_title__V-TJA","stat":"Header_stat__zKR9z","h1":"Header_h1__gcrm0"};